module.exports = __webpack_public_path__ + "static/media/Instructions.63cb7b02.svg";